import throttleAsyncFunction    from '@/client/utilities/throttleAsyncFunction.js';
import getAsyncOps              from '@/client/extensions/composition/asyncOperations.js';
import {helpers}                from '@vuelidate/validators';

export default function (options = {}) {
    let validator = (value) =>  {
        let runValidator = async (resolveCb, rejectCb) => {
            let requestResult = await await getAsyncOps({}).asyncCall('user/validation/email', {email:value}, {});

            if (requestResult.code !== 200) {
                rejectCb(false);
            } else {
                resolveCb(requestResult.data);
            }
        };

        return new Promise(async (resolve, reject) => {
            throttleAsyncFunction(runValidator, resolve, reject, options);
        });

    };

    return helpers.withParams(
        {type: 'uniqueEmail'},
        helpers.withAsync(validator)
    );
};
